var app = angular.module("leonardo");

var WhiteLabelBaseController = function($scope, PermissionService, WhiteLabelService, AuthDataService, ConfigThemeService,
                                        FolderFileService, FileService, ngDialog, AttachmentService) {

  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;
  $scope.showAdminPermissions = false;
  $scope.showPermissions = false;
  $scope.changed = false;
  $scope.errorSize = {
    logo1: false,
    logo2: false,
    logo3: false,
  };

  $scope.defaultConfigTheme = angular.copy(ConfigThemeService.config);


  $scope.getPermissionAdminKeys = function (group) {
    return filterKeys('permissionsAdmin', group);
  };

  $scope.getPermissionKeys = function (group) {
    return filterKeys('permissionsAccount', group);
  };

  function filterKeys(type, group) {
    var keys = [];
    angular.forEach(PermissionService[type], function (key) {
      if (_.contains(key, 'permission_') && !_.contains(key, '_all_') && _.contains(key, group)) {
        keys.push(key);
      }
    });
    return keys;
  }

  $scope.getClassPermissionsAdminAll = function (group) {
    if (!$scope.whiteLabel) {
      return '';
    }
    if (group == 'all') {
      $scope.whiteLabel.admin_permissions.permission_all = true;
      angular.forEach(PermissionService.permissionsAdmin, function (permission) {
        if (!$scope.whiteLabel.admin_permissions[permission]) {
          $scope.whiteLabel.admin_permissions.permission_all = false;
        }
      });
      if ($scope.whiteLabel.admin_permissions.permission_all) {
        return 'active';
      }
      else {
        return '';
      }
    }
    else {
      var keys = $scope.getPermissionAdminKeys(group);
      var active = true;
      angular.forEach(keys, function (key) {
        if (!$scope.whiteLabel.admin_permissions[key]) {
          active = false;
        }
      });
      if (active) {
        $scope.whiteLabel.admin_permissions['permission_all_' + group] = true;
        return 'active';
      }
      else {
        $scope.whiteLabel.admin_permissions['permission_all_' + group] = false;
        return '';
      }
    }
  };

  $scope.selectAllAdminPermissions = function (group) {
    if (!$scope.whiteLabel) return;
    if (group == 'all') {
      if (!$scope.whiteLabel.admin_permissions.permission_all) {
        angular.forEach(PermissionService.permissionsAdmin, function (permission) {
          $scope.whiteLabel.admin_permissions[permission] = true;
        });
      }
      else {
        angular.forEach(PermissionService.permissionsAdmin, function (permission) {
          $scope.whiteLabel.admin_permissions[permission] = false;
        });
      }
      $scope.whiteLabel.admin_permissions.permission_all = !$scope.whiteLabel.admin_permissions.permission_all;
    }
    else {
      var keys = $scope.getPermissionAdminKeys(group);
      if (!$scope.whiteLabel.admin_permissions['permission_all_' + group]) {
        angular.forEach(keys, function (key) {
          $scope.whiteLabel.admin_permissions[key] = true;
        });
      }
      else {
        angular.forEach(keys, function (key) {
          $scope.whiteLabel.admin_permissions[key] = false;
        });
      }
    }
  };

  $scope.getClassMaximumPermissionsAll = function (group) {
    if (!$scope.whiteLabel) {
      return '';
    }
    if (group == 'all') {
      $scope.whiteLabel.maximum_account_permissions.permission_all = true;
      angular.forEach(PermissionService.permissionsAccount, function (permission) {
        if (!$scope.whiteLabel.maximum_account_permissions[permission]) {
          $scope.whiteLabel.maximum_account_permissions.permission_all = false;
        }
      });
      if ($scope.whiteLabel.maximum_account_permissions.permission_all) {
        return 'active';
      }
      else {
        return '';
      }
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      var active = true;
      angular.forEach(keys, function (key) {
        if (!$scope.whiteLabel.maximum_account_permissions[key]) {
          active = false;
        }
      });
      if (active) {
        $scope.whiteLabel.maximum_account_permissions['permission_all_' + group] = true;
        return 'active';
      }
      else {
        $scope.whiteLabel.maximum_account_permissions['permission_all_' + group] = false;
        return '';
      }
    }
  };

  $scope.selectAllMaximumPermissions = function (group) {
    if (!$scope.whiteLabel) return;
    if (group == 'all') {
      if (!$scope.whiteLabel.maximum_account_permissions.permission_all) {
        angular.forEach(PermissionService.permissionsAccount, function (permission) {
          $scope.whiteLabel.maximum_account_permissions[permission] = true;
        });
      }
      else {
        angular.forEach(PermissionService.permissionsAccount, function (permission) {
          $scope.whiteLabel.maximum_account_permissions[permission] = false;
        });
      }
      $scope.whiteLabel.maximum_account_permissions.permission_all = !$scope.whiteLabel.default_account_permissions.permission_all;
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      if (!$scope.whiteLabel.maximum_account_permissions['permission_all_' + group]) {
        angular.forEach(keys, function (key) {
          $scope.whiteLabel.maximum_account_permissions[key] = true;
        });
      }
      else {
        angular.forEach(keys, function (key) {
          $scope.whiteLabel.maximum_account_permissions[key] = false;
        });
      }
    }
  };

  $scope.getClassPermissionsAll = function (group) {
    if (!$scope.whiteLabel) {
      return '';
    }
    if (group == 'all') {
      $scope.whiteLabel.default_account_permissions.permission_all = true;
      angular.forEach(PermissionService.permissionsAccount, function (permission) {
        if (!$scope.whiteLabel.default_account_permissions[permission]) {
          $scope.whiteLabel.default_account_permissions.permission_all = false;
        }
      });
      if ($scope.whiteLabel.default_account_permissions.permission_all) {
        return 'active';
      }
      else {
        return '';
      }
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      var active = true;
      angular.forEach(keys, function (key) {
        if (!$scope.whiteLabel.default_account_permissions[key]) {
          active = false;
        }
      });
      if (active) {
        $scope.whiteLabel.default_account_permissions['permission_all_' + group] = true;
        return 'active';
      }
      else {
        $scope.whiteLabel.default_account_permissions['permission_all_' + group] = false;
        return '';
      }
    }
  };

  $scope.selectAllPermissions = function (group) {
    if (!$scope.whiteLabel) return;
    if (group == 'all') {
      if (!$scope.whiteLabel.default_account_permissions.permission_all) {
        angular.forEach(PermissionService.permissionsAccount, function (permission) {
          $scope.whiteLabel.default_account_permissions[permission] = true;
        });
      }
      else {
        angular.forEach(PermissionService.permissionsAccount, function (permission) {
          $scope.whiteLabel.default_account_permissions[permission] = false;
        });
      }
      $scope.whiteLabel.default_account_permissions.permission_all = !$scope.whiteLabel.default_account_permissions.permission_all;
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      if (!$scope.whiteLabel.default_account_permissions['permission_all_' + group]) {
        angular.forEach(keys, function (key) {
          $scope.whiteLabel.default_account_permissions[key] = true;
        });
      }
      else {
        angular.forEach(keys, function (key) {
          $scope.whiteLabel.default_account_permissions[key] = false;
        });
      }
    }
  };

  $scope.updateName = function () {
    ConfigThemeService.updateName($scope.whiteLabel.name || $scope.defaultConfigTheme.name);
  };

  $scope.updateConfig = function () {
    ConfigThemeService.updateTheme($scope.whiteLabel.theme_config);
  };

  $scope.onFileUpload = function(file, logo, notUpload) {
    if (!file) {
      return;
    }
    var svg = file.name ? file.name.split('.svg') : [];
    if (!notUpload && (svg.length === 1)){
      ngDialog.openConfirm({
        template: 'views/templates/dialog/attachment/image-crop.html',
        className: 'ngdialog-theme-default ngdialog-iframe',
        controller: 'ImageCrop',
        data: {
          file: file
        }
      }).then(function (file_result) {
        $scope.errorSize[logo] = AttachmentService.checkErrorSize(file_result);
        if ($scope.errorSize[logo]) {
          return;
        }
        $scope[logo] = file_result;
        $scope.whiteLabel[logo] = file_result;
        var fd = new FormData();
        fd.append('file', file_result);
        $scope.whiteLabel[logo].file = fd;
      });
    }
    else {
      $scope.errorSize[logo] = AttachmentService.checkErrorSize(file);
      if ($scope.errorSize[logo]) {
        return;
      }
      $scope[logo] = $scope.whiteLabel[logo] ? angular.copy($scope.whiteLabel[logo]) : file;
      $scope.whiteLabel[logo] = file;
      var formdata = new FormData();
      formdata.append('file', file);
      $scope.whiteLabel[logo].file = formdata;
    }

    if (!notUpload) {
      var reader  = new FileReader();

      reader.onloadend = function () {
        ConfigThemeService.updateLogo(logo, reader.result);
        ConfigThemeService.updating = true;
      };

      if (file) {
        reader.readAsDataURL(file);
      } else {
        ConfigThemeService.updateLogo(logo, $scope.defaultConfigTheme[logo]);
        ConfigThemeService.updating = false;
      }
    }
  };

  $scope.removeFile = function(logo) {
    $scope.errorSize[logo] = false;
    $scope.whiteLabel[logo] = null;
    $scope[logo] = null;
    ConfigThemeService.updateLogo(logo, $scope.defaultConfigTheme[logo]);
    ConfigThemeService.updating = false;
  };

  $scope.initLogo = function(logo) {
    if($scope.whiteLabel[logo]) {
      FolderFileService.getFileObject($scope.whiteLabel[logo], function (fileObject) {
        if (fileObject) {
          var array_url = $scope.whiteLabel[logo].split('/');
          var array_filename = array_url[array_url.length - 1].split('.');
          var file = new FileService([fileObject], array_url[array_url.length-1], {type: 'image/' + array_filename[array_filename.length-1]});
          ConfigThemeService.updateLogo(logo, $scope.whiteLabel[logo]);
          ConfigThemeService.updating = true;
          $scope.onFileUpload(file, logo, true);
          $scope.$apply();
        }
        else {
          $scope.whiteLabel[logo] = null;
          $scope.$apply();
        }
      });
    }
  };

  $scope.initData = function () {
    angular.forEach(PermissionService.permissionsAdmin, function (key) {
      if (isNull($scope.whiteLabel.admin_permissions[key])) {
        $scope.whiteLabel.admin_permissions[key] = false;
      }
    });
    angular.forEach(PermissionService.permissionsAccount, function (key) {
      if (isNull($scope.whiteLabel.default_account_permissions[key])) {
        $scope.whiteLabel.default_account_permissions[key] = false;
      }
    });
    $scope.initLogo('logo1');
    $scope.initLogo('logo2');
    $scope.initLogo('logo3');
    ConfigThemeService.updateName($scope.whiteLabel.name || $scope.defaultConfigTheme.name);
    ConfigThemeService.updateTheme($scope.whiteLabel.theme_config);
  };

  $scope.getData = function() {
    return {
      name: $scope.whiteLabel.name,
      logo1: $scope.whiteLabel.logo1 || '',
      logo2: $scope.whiteLabel.logo2 || '',
      logo3: $scope.whiteLabel.logo3 || '',
      default_from_email: $scope.whiteLabel.default_from_email,
      company_help_email: $scope.whiteLabel.company_help_email,
      theme_config: JSON.stringify($scope.whiteLabel.theme_config),
      url_config: JSON.stringify($scope.whiteLabel.url_config),
      admin_permissions: JSON.stringify($scope.whiteLabel.admin_permissions),
      default_account_permissions: JSON.stringify($scope.whiteLabel.default_account_permissions)
    };
  };

  $scope.goBack = function() {
    window.history.back();
  };

  $scope.$on('$destroy', function () {
    if (!$scope.changed) {
      ConfigThemeService.updateConfig($scope.defaultConfigTheme);
    }
    ConfigThemeService.updating = false;
  })
};

app.controller('WhiteLabelBaseController', ['$scope', 'PermissionService', 'WhiteLabelService', 'AuthDataService',
  'ConfigThemeService',  'FolderFileService', 'FileService', 'ngDialog', 'AttachmentService', WhiteLabelBaseController]);